module.exports = __webpack_public_path__ + "static/media/roboto-bold-webfont.a5a0afe5.woff";